import { useCallback } from "react";
import { Target } from "lucide-react";

import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import {
  invalidateMetaLeadsEventsTableQuery,
  useMetaLeadsEventsTable,
} from "hooks/useMetaLeadsEventsTable";
import MetaLeadsEventService from "services/MetaLeadsEvent";
import MetaLeadsEventModal from "routes/meta_leads_events/components/MetaLeadsEventModal";

export const META_LEADS_EVENTS_TABLE_CONSTANTS = {
  tableName: "meta_leads_events",
  queryKey: "meta_leads_events_table",
  className: "MetaLeadsEvent",
  header: "Meta Leads Events",
  headerIcon: Target,
};

const MetaLeadsEventsTableV3 = () => {
  const { filters, columns } = useMetaLeadsEventsTable({
    tableName: META_LEADS_EVENTS_TABLE_CONSTANTS.tableName,
  });

  const fetchEvents = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      return MetaLeadsEventService.getTable(nextQueryParams);
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={META_LEADS_EVENTS_TABLE_CONSTANTS.headerIcon}
      header={META_LEADS_EVENTS_TABLE_CONSTANTS.header}
      tableName={META_LEADS_EVENTS_TABLE_CONSTANTS.tableName}
      queryKey={META_LEADS_EVENTS_TABLE_CONSTANTS.queryKey}
      className={META_LEADS_EVENTS_TABLE_CONSTANTS.className}
      fetchData={fetchEvents}
      createButton={
        <MetaLeadsEventModal onSuccess={invalidateMetaLeadsEventsTableQuery} />
      }
      enableSearch
      enableSettings
      invalidateData={invalidateMetaLeadsEventsTableQuery}
    />
  );
};

export default MetaLeadsEventsTableV3;
